<template>
  <div>
    <search-header :form="searchForm" :formInline="formInline" @on-event="searchEvent"></search-header>
    <Table border :columns="columns" :data="data" :max-height="max_height" :loading="loading"></Table>
   <Page
      class-name="page"
      :total="total"
      size="small"
      show-sizer
      show-total
      show-elevator
      @on-change="changePage"
      @on-page-size-change="changeSize"
    />
  </div>
</template>
<script>
import SearchHeader from "../../components/SearchHeader";
import YnModal from "../../components/YnModal"
import { $getBrowerHeight,$formatDate } from "../../tools";
//获取公共的接口
import { dictDataList, provinceList, nextList } from "./../../http/commom";
//获取本页面的接口
import { selectMylabListByPage } from "./../../http/customer";

export default {
  components: { SearchHeader,YnModal},
  data() {
    return {
      loading:true,
      add:false,//添加模态框
      max_height: 0,
      current: 1,
      size: 10,
      total: 0,
      searchForm: [
        {
          fromType: "Input",
          type: "text",
          place: "实验室名称",
          value: "labName"
        },
        { fromType: "Select", place: "接口状态", value: "state", arr: [] },
        { fromType: "Button", type: "primary", place: "搜索", event: "search" },
        { fromType: "Button", type: "primary", place: "重置", event: "reset" },
      ],
      formInline: {},
       columns: [
        {
          title: "实验室名称",
          align:'center',
          minWidth: 150,
          ellipsis: true,
          key: "name"
        },
        {
          title: "接口地址",
          align:'center',
          minWidth: 200,
          ellipsis: true,
          key: "apiAddress"
        },
        {
          title: "帐号",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "code"
        },
        {
          title: "密码",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "dataPassword"
        },
        {
          title: "接口协议",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "apiType"
        },
        {
          title: "接口状态",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "enabled"
        },
        {
          title: "接入时间",
          align:'center',
          minWidth: 150,
          ellipsis: true,
          key: "createTime"
        },
        {
          title: "联系人",
          align:'center',
          minWidth: 100,
          ellipsis: true,
          key: "contact"
        },
        {
          title: "联系电话",
          align:'center',
          minWidth: 150,
          ellipsis: true,
          key: "contactPhone"
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          fixed: "right",
          width: 250,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                        this.$router.push({path:'/customerMap',query:{id:params.row.id,enabled:params.row.enabled}});
                    }
                  }
                },
                "项目映射"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                        this.$router.push({path:'/customerSampleM',query:{id:params.row.id,enabled:params.row.enabled}});
                    }
                  }
                },
                "标本管理"
              ),
               h(
                "Button",
                {
                  props: {
                    type: "default",
                    size: "small"
                  },
                  on: {
                    click: () => {
                        this.$router.push({path:'/excel',query:{id:params.row.id}});
                    }
                  }
                },
                "Excel上传"
              )
            ]);
          }
        }
      ],
      data: [],
      //数据处理
      api_type: [], //接口协议
      data_type: [], //客户类型
      data_lab_type: [], //客户对接类型
      province: [], //省份列表
      //搜索数据
      searchData:{
        labName:'',
        state:''
      },
      key:'',
    };
  },
  mounted() {
      this.max_height = this.$getBrowerHeight();
    window.onresize = () => {
      this.max_height = this.$getBrowerHeight();
    };
    this.init();
  },
  methods: {
      //基础数据获取
      init(){
        //字典
        dictDataList().then(res => {
          this.api_type = res.filter(item => item.t === "data_api_type")[0].list;
         this.getList();
        });
        //接口数据
        this.searchForm[1].arr = [
          {
          code:0,
          name:'不可用'
          },
          {
          code:1,
          name:'可用'
          }
        ];
        //获取缓存值
         this.key= localStorage.getItem("data-center-token");
      },
      //获取列表
    getList(){
       selectMylabListByPage({
        "current": this.current,
        "enabled": this.searchData.state,
        "key": this.key,
        "labName": this.searchData.labName,
        "size": this.size
      }).then(res => {
        res.records.forEach(item => {
          item.createTime = this.$formatDate(item.createTime, "01", "03");
          this.api_type.map(api => {
            if (item.apiType == api.code) {
              item.apiType = api.name;
            }
          });
          this.searchForm[1].arr.map(api=>{
            if (item.enabled == api.code) {
              item.enabled = api.name;
            }
          })
        });
        this.data = res.records;
        this.total = res.total;
        this.loading = false;
      });
    },
    //搜索组件按钮
    searchEvent(obj) {
      this[obj.type](obj);
    },
    search(obj) {
      this.loading = true;
      this.searchData = obj;
      this.getList();
    },
    reset(obj) {
      this.formInline = {};
      this.searchData = {};
      this.getList();
    },
    //改变页码
    changePage(page) {
      this.loading = true;
      this.current = page;
      this.getList();
    },
    //改变每页显示条数
    changeSize(size) {
      this.loading = true;
      this.size = size;
      this.getList();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/customer/customer.vue